import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { NgToastConfig, provideNgToast } from 'ng-angular-popup';

import Aura from '@primeuix/themes/aura';
import { defaultLanguageCode } from '@app/models/language.model';
import { definePreset } from '@primeuix/themes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';

const toasterConfig: Partial<NgToastConfig> = {
  duration: 3000,              // Default 5 seconds
  position: 'toaster-top-right',       // Default position
  maxToasts: 3,                // Max 3 toasts at once
  width: 400,                  // Toast width in pixels
  showProgress: true,          // Show progress bar
  dismissible: true,           // Allow manual dismiss
  showIcon: true,              // Show icons
  enableAnimations: true       // Enable animations
};

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{red.50}',
            100: '{red.100}',
            200: '{red.200}',
            300: '{red.300}',
            400: '{red.400}',
            500: '{red.500}',
            600: '{red.600}',
            700: '{red.700}',
            800: '{red.800}',
            900: '{red.900}',
            950: '{red.950}'
        }
    }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: defaultLanguageCode,
      lang: defaultLanguageCode
    }),
    providePrimeNG({
        theme: {
            preset: MyPreset,
            options: {
                darkModeSelector: false,
            }
        }
    }),
    provideNgToast(toasterConfig),
  ]
};
